'use strict';

const searchHelper = require('progamers_core/components/search-helper');
var debounce = require('lodash/debounce');
var endpoint = $('.suggestions-wrapper').data('url');
const scrollToElement = require('progamers_core/components/scrollToElement');

var minChars = 3;

const $mainContent = $('#maincontent');
const $instantSearchWrapper = $('.js-instant-search-result-wrapper:first');
let isSearchRunning = false;
const initialPageURL = window.location.href;
let lastSearch = '';

const searchFieldSelector = 'input.search-field';
const searchResultsWrapper = '.js-search-results';
const isInitialPageSearchResultsPage = !!(document.querySelector(searchResultsWrapper));
let permalinkAjaxURLBeforeInstantSearch = '';
let isInitialPageServed = true;

function ajaxInstantSearch(scope, ajaxUrl) {
    let finalAjaxUrl = ajaxUrl + '&render-search-resources=true';
    $.spinner().start();
    $.ajax({
        context: scope,
        url: finalAjaxUrl,
        method: 'GET',
        success: function (html) {
            if (searchHelper.handleSearchRedirect(html)) {
                return;
            }
            $instantSearchWrapper.html(html);
            $instantSearchWrapper.show();
            $mainContent.hide();
            const updatedURL = $instantSearchWrapper.find('.permalink')[0]?.value || '';
            window.history.pushState(null, '', updatedURL);

            const scrollTargetElement = document.querySelector('body');
            if (scrollTargetElement) {
                scrollToElement(scrollTargetElement, false);
            }
        },
        error: function (err) {
            console.error(err);
        },
        complete: function () {
            isSearchRunning = false;
            $.spinner().stop();
        }
    });
}

function triggerCatalogSearch(ajaxUrl, isResetInstantSearch = false) {
    const eventData = {
        detail: {
            url: ajaxUrl,
            additionalDispatchDataOnUpdateUrl: {
                isResetInstantSearch
            }
        }
    };
    document.dispatchEvent(new CustomEvent('run-catalog-search', eventData));
    if (!isInitialPageSearchResultsPage) {
        $mainContent.hide();
        $instantSearchWrapper.show();
    }
}

/**
 * Instant search
 *
 * @param {Object} scope - Search field DOM element
 */
function applyInstantSearch(scope) {
    if (!$instantSearchWrapper.length) {
        console.error('Instant search can\'t run - instantSearchWrapper doesn\'t exist in DOM.');
        return;
    }
    if (isSearchRunning) {
        return;
    }

    $(scope).siblings('.reset-button').toggleClass('d-none', $(scope).val().length === 0);

    if ($(scope).val().length >= minChars) {
        isInitialPageServed = false;
        if (lastSearch === $(scope).val()) {
            return;
        }
        let ajaxUrl = endpoint + encodeURIComponent($(scope).val());
        isSearchRunning = true;
        let isSearchResultsPage = document.querySelector(searchResultsWrapper);
        if (!isSearchResultsPage) {
            ajaxInstantSearch(scope, ajaxUrl);
        } else {
            triggerCatalogSearch(ajaxUrl);
        }
    } else if (!isInitialPageServed) {
        if (!isInitialPageSearchResultsPage) {
            $mainContent.show();
            $instantSearchWrapper.hide();
            window.history.pushState(null, '', initialPageURL);
        } else {
            let isResetInstantSearch = true;
            triggerCatalogSearch(permalinkAjaxURLBeforeInstantSearch, isResetInstantSearch);
        }
    }
    lastSearch = $(scope).val();
}

module.exports = function () {
    searchHelper.restoreSearchFieldFromUrl();
    searchHelper.persistSortRuleOnSubmit();

    $('input.search-field').each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        var debounceInstantSearch = debounce(applyInstantSearch, 1000);
        $(this).on('keyup', function (e) {
            debounceInstantSearch(this, e);
        });
    });

    $('.site-search .reset-button').on('click', function () {
        $(this).addClass('d-none');

        const searchField = this.closest('form').querySelector(searchFieldSelector);
        if (searchField) {
            searchField.value = '';
            applyInstantSearch(searchField);
        }
    });

    document.addEventListener('search:filtered', () => {
        isSearchRunning = false;
    });

    if (isInitialPageSearchResultsPage) {
        permalinkAjaxURLBeforeInstantSearch = document.querySelector('.permalink')?.value || '';
        document.addEventListener('search:update-ajax-url', (e) => {
            const newUrl = e?.detail?.url;
            if (isInitialPageServed && newUrl) {
                permalinkAjaxURLBeforeInstantSearch = newUrl;
            }
            if (e?.detail?.additionalDispatchData?.isResetInstantSearch) {
                isInitialPageServed = true;
            }
        });
    }

    searchHelper.initHistoryBackForwardRefreshResults();
};
